import React, { useState } from "react";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { animated, useSpring } from "react-spring";
import { screens } from "../../constants/constants";
import { springConfigs } from "../../constants/springConfigs";
import { useWindowSize } from "../../hooks/useWindowSize";
import { OnCurtainStart } from "../../types/types";

const HalfCircle = ({ animatedOffset, mirror, color, left }) => {
  return (
    <svg width="100%" viewBox="-1 -2 52 104">
      <animated.path
        stroke={color}
        fill="transparent"
        strokeWidth={left ? 1.5 : 3}
        pathLength="1"
        strokeDasharray="1"
        strokeDashoffset={animatedOffset}
        /* rx ry x-axis-rotation large-arc-flag sweep-flag x y */
        d={`
              M ${mirror ? -1 : 51} 100 
              A 50 50 0 0 ${mirror ? 0 : 1} ${mirror ? -2 : 52}  0
          `}
      />
    </svg>
  );
};

export const CircularButtonBorder = ({ animatedOffset, color, left }) => {
  return (
    <div
      id="CircularButtonBorder"
      style={{
        gridArea: "center",
        display: "grid",
        gridTemplate: `
      "left right"
    `,
      }}
    >
      <HalfCircle {...{ animatedOffset, mirror: false, color, left }} />
      <HalfCircle {...{ animatedOffset, mirror: true, color, left }} />
    </div>
  );
};

const CircularButton = ({
  animatedOffset,
  color,
  left,
  onCurtainStart,
  screenLeft,
  screenRight,
  containerStyle,
}: {
  animatedOffset: any;
  color: string;
  left: boolean;
  onCurtainStart: OnCurtainStart;
  screenLeft: string;
  screenRight: string;
  containerStyle?: React.CSSProperties;
}) => {
  const [hover, hoverSet] = useState(false);

  /* for arrow to appear */
  const { padding } = useSpring({
    from: { padding: "120%" },
    to: { padding: "0%" },
    config: springConfigs.outlineAppear,
  });
  /* for inner arrow to move on hover */
  const { marginLeft } = useSpring({
    from: { marginLeft: hover ? "0px" : "0px" },
    to: { marginLeft: hover ? (left ? "-4px" : "4px") : "0px" },
  });

  const { w, h } = useWindowSize();

  return (
    <div
      id="CircularButton"
      style={{
        cursor: "pointer",
        display: "grid",
        gridTemplate: `
      "center"
      `,
        overflow: "hidden",
        ...containerStyle,
      }}
      onClick={() =>
        onCurtainStart({
          curtainTo: left ? screenLeft : screenRight,
          horizontal: true,
          toLeft: left,
        })
      }
      onMouseEnter={() => {
        hoverSet(true);
      }}
      onMouseLeave={() => {
        hoverSet(false);
      }}
    >
      {/* border */}
      <CircularButtonBorder {...{ animatedOffset, color, left }} />
      {/* caret */}
      <animated.div
        style={{
          marginLeft,
          placeSelf: "center",
          gridArea: "center",
          fontSize: h(3),
          lineHeight: h(3),
          justifyContent: "center",
          paddingLeft: left ? padding : "",
          paddingRight: left ? "" : padding,
        }}
      >
        {left && <BiChevronLeft />}
        {!left && <BiChevronRight />}
      </animated.div>
    </div>
  );
};

export { CircularButton };
